import React, { useState, useEffect } from "react";
import axios from "axios";
import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import swal from "sweetalert";
import {
    Box,
    Button,
    Container,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Select,
    MenuItem,
    FormControl,
    IconButton,
    Avatar,
    Grid,
    Typography,
    Tabs,
    Tab,
    Divider
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
const mapTcgToLeyi = (tcgCode) => {
    if (!tcgCode) return "";
    const map = {
        "4": "AG", "16": "CQ9", "27": "DG", "28": "ALLBET", "39": "PP",
        "43": "MG", "47": "SS", "54": "SBO", "9164": "POLY", "9329": "DBTY",
        "55": "JDB", "79": "BBZR", "86": "EVO", "93": "SA", "98": "PGS",
        "99": "TFG", "102": "V8", "104": "CMD", "111": "PT", "112": "PGA",
        "118": "DBZR", "121": "KM", "123": "KP", "132": "SV388", "140": "JILI",
        "141": "FC", "142": "FB", "151": "IM", "161": "BNG", "168": "MW",
        "174": "IBC", "191": "EVO", "202": "WS168", "249": "5G"
    };
    return map[String(tcgCode)] || "";
};

const mapTcgToFs = (tcgCode) => {
    if (!tcgCode) return "";
    const map = {
        "4": "PA", "16": "CQ9", "27": "DG", "28": "AB", "39": "PP",
        "43": "MG", "47": "SS", "54": "SBOG", "55": "JDB", "79": "BBIN",
        "86": "EVOL", "93": "SA", "98": "PG", "99": "LH", "102": "KY",
        "104": "IBC", "111": "PT", "112": "SY", "118": "WM", "121": "KM",
        "123": "KY", "132": "AOG", "140": "JILI", "141": "FC", "142": "FB",
        "151": "IM", "161": "BNG", "168": "MW", "174": "IBC", "191": "EVOL",
        "202": "AOG",
        "249": "G5", "9164": "DBS", "9329": "DBS"
    };
    return map[String(tcgCode)] || "";
};

const mapCodeToTcg = (code) => {
    if (!code) return "";
    const lower = code.toLowerCase();
    const map = {
        "saba": "174", "sbo": "54", "crown": "9164", "bti": "47", "dgt": "9329", "fb": "142",
        "dbzr": "118", "dg": "27", "ae": "112", "evo": "86", "ag": "4", "mg": "43", "pp": "39", "sa": "93", "allbet": "28",
        "sv388": "132", "ws168": "202",
        "pg": "98", "jili": "140", "pp_slots": "39", "fc_slots": "141", "jdb_slots": "55", "mg_slots": "43", "cq9_slots": "16", "pt_slots": "111", "bbin_slots": "79",
        "jili_fish": "140", "fc_fish": "141", "jdb_fish": "55",
        "v8": "102", "km": "121", "ky": "123",
        "tf_esport": "99", "im_esport": "61"
    };
    return map[lower] || "";
};

const getImageUrl = (url) => {
    if (!url) return "";
    let cleanUrl = url;
    const serverUrl = process.env.REACT_APP_API_URL_MAIN || process.env.REACT_APP_API_URL || "";
    if (cleanUrl.startsWith("/")) {
        return serverUrl + cleanUrl;
    }
    cleanUrl = cleanUrl.replace("https://server.mingclub.live", serverUrl);
    if (cleanUrl.includes("server2.mingclub.live") && process.env.REACT_APP_API_URL_MAIN) {
        cleanUrl = cleanUrl.replace("https://server2.mingclub.live", process.env.REACT_APP_API_URL_MAIN);
    }
    return cleanUrl;
};

function Lobbies() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    // Tab State
    const [selectedTab, setSelectedTab] = useState("All");

    // Form States
    const [id, setId] = useState("");
    const [name, setName] = useState("");
    const [code, setCode] = useState("");
    const [image, setImage] = useState(""); // Ảnh sảnh gốc
    const [imagePc, setImagePc] = useState("");
    const [imageMobile, setImageMobile] = useState("");
    const [logoPc, setLogoPc] = useState("");
    const [logoMobile, setLogoMobile] = useState("");
    const [category, setCategory] = useState("Slots");
    const [status, setStatus] = useState("Active");
    const [sortOrder, setSortOrder] = useState(0);
    const [productType, setProductType] = useState("");
    const [gameCode, setGameCode] = useState("");
    const [gameType, setGameType] = useState("");
    const [codeLeYi, setCodeLeYi] = useState("");
    const [codeFS, setCodeFS] = useState("");

    const handleUploadImage = (e, fieldType) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("file", file);

        setLoading(true);
        axios
            .post(`${process.env.REACT_APP_API_URL}/lobby/upload`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            })
            .then((res) => {
                setLoading(false);
                const filePath = res.data.data.filePath;
                
                if (fieldType === "image") setImage(filePath);
                else if (fieldType === "imagePc") setImagePc(filePath);
                else if (fieldType === "imageMobile") setImageMobile(filePath);
                else if (fieldType === "logoPc") setLogoPc(filePath);
                else if (fieldType === "logoMobile") setLogoMobile(filePath);

                swal("Thành công", "Tải ảnh lên thành công!", "success");
            })
            .catch((err) => {
                setLoading(false);
                console.error(err);
                swal("Thất bại", err.response?.data?.message || "Không thể tải ảnh lên!", "error");
            });
    };

    const categories = [
        { value: "All", label: "Tất cả" },
        { value: "Slots", label: "Slots (Nổ hũ)" },
        { value: "Live", label: "Live Casino" },
        { value: "Sports", label: "Sports (Thể thao)" },
        { value: "Fish", label: "Fish (Bắn cá)" },
        { value: "PVP", label: "PVP (Đối kháng)" },
        { value: "Lottery", label: "Lottery (Xổ số)" },
        { value: "Cockfight", label: "Cockfight (Đá gà)" },
        { value: "Esports", label: "Esports (Thể thao điện tử)" }
    ];

    const fetchLobbies = () => {
        setLoading(true);
        axios
            .get(`${process.env.REACT_APP_API_URL}/lobby/list`)
            .then((res) => {
                setData(res.data.data);
                setLoading(false);
            })
            .catch((err) => {
                console.error(err);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchLobbies();
    }, []);

    const handleOpen = (lobby = null) => {
        if (lobby) {
            setId(lobby._id);
            setName(lobby.name);
            setCode(lobby.code);

            let img = lobby.image || "";
            let imgPc = lobby.imagePc || "";
            let imgMobile = lobby.imageMobile || "";
            let lgPc = lobby.logoPc || "";
            let lgMobile = lobby.logoMobile || "";

            const serverUrl = process.env.REACT_APP_API_URL || "";

            if (img.includes("server.mingclub.live")) {
                img = img.replace("https://server.mingclub.live", serverUrl);
            }
            if (imgPc.includes("server.mingclub.live")) {
                imgPc = imgPc.replace("https://server.mingclub.live", serverUrl);
            }
            if (imgMobile.includes("server.mingclub.live")) {
                imgMobile = imgMobile.replace("https://server.mingclub.live", serverUrl);
            }
            if (lgPc.includes("server.mingclub.live")) {
                lgPc = lgPc.replace("https://server.mingclub.live", serverUrl);
            }
            if (lgMobile.includes("server.mingclub.live")) {
                lgMobile = lgMobile.replace("https://server.mingclub.live", serverUrl);
            }

            setImage(img);
            setImagePc(imgPc);
            setImageMobile(imgMobile);
            setLogoPc(lgPc);
            setLogoMobile(lgMobile);
            setCategory(lobby.category);
            setStatus(lobby.status);
            setSortOrder(lobby.sortOrder);
            setProductType(lobby.productType || "");
            setGameCode(lobby.gameCode || "");
            setGameType(lobby.gameType || "");

            // Tự động điền (ánh xạ) mã sảnh chính dựa theo productType (mã TCG) nếu trong DB đang bị rỗng
            setCodeLeYi(lobby.codeLeYi || mapTcgToLeyi(lobby.productType) || lobby.code || "");
            setCodeFS(lobby.codeFS || mapTcgToFs(lobby.productType) || lobby.code || "");
        } else {
            setId("");
            setName("");
            setCode("");
            setImage("");
            setImagePc("");
            setImageMobile("");
            setLogoPc("");
            setLogoMobile("");
            setCategory("Slots");
            setStatus("Active");
            setSortOrder(0);
            setProductType("");
            setGameCode("");
            setGameType("");
            setCodeLeYi("");
            setCodeFS("");
        }
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = () => {
        if (!name || !code) {
            swal("Lỗi", "Vui lòng điền tên và mã sảnh!", "error");
            return;
        }

        const payload = {
            id,
            name,
            code,
            image, // Gửi ảnh sảnh gốc
            imagePc,
            imageMobile,
            logoPc,
            logoMobile,
            category,
            status,
            sortOrder: Number(sortOrder),
            productType,
            gameCode,
            gameType,
            codeLeYi,
            codeFS
        };

        axios
            .post(`${process.env.REACT_APP_API_URL}/lobby/save`, payload)
            .then((res) => {
                swal("Thành công", res.data.message || "Đã lưu cấu hình sảnh game!", "success");
                fetchLobbies();
                handleClose();
            })
            .catch((err) => {
                console.error(err);
                swal("Thất bại", err.response?.data?.message || "Không thể lưu cấu hình!", "error");
            });
    };

    const handleDelete = (lobbyId) => {
        swal({
            title: "Xác nhận xóa?",
            text: "Hành động này không thể hoàn tác!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                axios
                    .delete(`${process.env.REACT_APP_API_URL}/lobby/delete/${lobbyId}`)
                    .then((res) => {
                        swal("Thành công", res.data.message, "success");
                        fetchLobbies();
                    })
                    .catch((err) => {
                        swal("Lỗi", "Không thể xóa sảnh game", "error");
                    });
            }
        });
    };

    const handleToggleStatus = (lobby, newStatus) => {
        axios
            .post(`${process.env.REACT_APP_API_URL}/lobby/toggle`, { id: lobby._id, status: newStatus })
            .then((res) => {
                swal("Thành công", `Đã chuyển sảnh ${lobby.name} sang ${newStatus}`, "success");
                fetchLobbies();
            })
            .catch((err) => {
                swal("Lỗi", "Không thể cập nhật trạng thái sảnh", "error");
            });
    };

    const filteredData = selectedTab === "All"
        ? data
        : data.filter(lobby => lobby.category === selectedTab);

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        py: 2
                    }}>
                    {loading && (
                        <div className="loading" style={{ maxWidth: "100%" }}>
                            <div className="loader"></div>
                        </div>
                    )}
                    <Container maxWidth={false}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                            <div className="container_set" style={{ margin: 0 }}>Cấu hình sảnh game</div>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<AddIcon />}
                                onClick={() => handleOpen()}
                            >
                                Thêm Sảnh Mới
                            </Button>
                        </Box>

                        {/* Tab phân loại ngang */}
                        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2, bgcolor: "#fff", borderRadius: "8px", p: 0.5 }}>
                            <Tabs
                                value={selectedTab}
                                onChange={(e, val) => setSelectedTab(val)}
                                variant="scrollable"
                                scrollButtons="auto"
                                textColor="primary"
                                indicatorColor="primary"
                            >
                                {categories.map((cat) => (
                                    <Tab
                                        key={cat.value}
                                        value={cat.value}
                                        label={cat.label}
                                        sx={{ fontWeight: "bold", fontSize: "14px" }}
                                    />
                                ))}
                            </Tabs>
                        </Box>

                        <div className="form_set">
                            <Box sx={{ overflowX: "auto" }}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ padding: "10px" }}>Ảnh sảnh gốc</TableCell>
                                            <TableCell sx={{ padding: "10px" }}>Logo PC</TableCell>
                                            <TableCell sx={{ padding: "10px" }}>Logo Mobile</TableCell>
                                            <TableCell sx={{ padding: "10px" }}>Tên sảnh</TableCell>
                                            <TableCell sx={{ padding: "10px" }}>Mã sảnh (Code)</TableCell>
                                            <TableCell sx={{ padding: "10px" }}>Phân loại (Tab)</TableCell>
                                            <TableCell sx={{ padding: "10px" }}>Thứ tự sắp xếp</TableCell>
                                            <TableCell sx={{ padding: "10px" }}>Trạng thái</TableCell>
                                            <TableCell sx={{ padding: "10px" }}>Hành động</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredData.length > 0 ? (
                                            filteredData.map((lobby) => {
                                                const pcLogo = lobby.imagePc || lobby.image || "";
                                                const mobileLogo = lobby.imageMobile || "";
                                                return (
                                                    <TableRow key={lobby._id}>
                                                        <TableCell sx={{ padding: "10px" }}>
                                                            <Avatar
                                                                src={getImageUrl(lobby.image)}
                                                                alt={lobby.name}
                                                                variant="rounded"
                                                                sx={{ width: 45, height: 45, bgcolor: "#eee" }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>
                                                            <Avatar
                                                                src={getImageUrl(pcLogo)}
                                                                alt={lobby.name}
                                                                variant="rounded"
                                                                sx={{ width: 45, height: 45, bgcolor: "#eee" }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>
                                                            <Avatar
                                                                src={getImageUrl(mobileLogo)}
                                                                alt={lobby.name}
                                                                variant="rounded"
                                                                sx={{ width: 45, height: 45, bgcolor: "#eee" }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{lobby.name}</TableCell>
                                                        <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{lobby.code}</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>
                                                            <span className="badge warning" style={{ backgroundColor: "#1976d2" }}>
                                                                {lobby.category}
                                                            </span>
                                                        </TableCell>
                                                        <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{lobby.sortOrder}</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>
                                                            <Select
                                                                value={lobby.status}
                                                                size="small"
                                                                onChange={(e) => handleToggleStatus(lobby, e.target.value)}
                                                                sx={{
                                                                    height: "30px",
                                                                    fontSize: "13px",
                                                                    minWidth: "120px",
                                                                    "& .MuiSelect-select": {
                                                                        color: lobby.status === "Active" ? "green" : lobby.status === "Maintenance" ? "orange" : "red",
                                                                        fontWeight: "bold"
                                                                    }
                                                                }}
                                                            >
                                                                <MenuItem value="Active">Hoạt động</MenuItem>
                                                                <MenuItem value="Maintenance">Bảo trì</MenuItem>
                                                                <MenuItem value="Disabled">Tắt sảnh</MenuItem>
                                                            </Select>
                                                        </TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>
                                                            <IconButton color="primary" onClick={() => handleOpen(lobby)}>
                                                                <EditIcon size="small" />
                                                            </IconButton>
                                                            <IconButton color="error" onClick={() => handleDelete(lobby._id)}>
                                                                <DeleteIcon size="small" />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={8} align="center">Không tìm thấy cấu hình sảnh game nào.</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </Box>
                        </div>
                    </Container>
                </Box>
            </DashboardLayout>

            {/* Dialog Form */}
            <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
                <DialogTitle sx={{ pb: 1.5, borderBottom: "1px solid #eee", fontWeight: "bold" }}>
                    {id ? "Chỉnh sửa cấu hình sảnh game" : "Thêm cấu hình sảnh game mới"}
                </DialogTitle>
                <DialogContent sx={{ pt: 3 }}>
                    <Grid container spacing={2.5}>
                        {/* Cột trái: Thông tin cơ bản */}
                        <Grid item xs={12} md={6} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                            <Box>
                                <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "700", color: "text.secondary", textTransform: "uppercase" }}>
                                    Tên sảnh game
                                </Typography>
                                <TextField
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    fullWidth
                                    size="small"
                                    placeholder="Ví dụ: PG Slots, JILI Slots, SABA Sports..."
                                />
                            </Box>

                            <Box>
                                <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "700", color: "text.secondary", textTransform: "uppercase" }}>
                                    Mã sảnh chính (Code)
                                </Typography>
                                <TextField
                                    value={code}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        setCode(val);
                                        if (!id) {
                                            const lowerVal = val.toLowerCase();
                                            const tcgVal = mapCodeToTcg(lowerVal);
                                            setProductType(tcgVal);
                                            setCodeLeYi(mapTcgToLeyi(tcgVal) || lowerVal);
                                            setCodeFS(mapTcgToFs(tcgVal) || lowerVal);
                                        }
                                    }}
                                    fullWidth
                                    size="small"
                                    disabled={!!id}
                                    placeholder="Ví dụ: pg, jili, saba (Không thay đổi sau khi tạo)"
                                />
                            </Box>

                            <Box>
                                <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "700", color: "text.secondary", textTransform: "uppercase" }}>
                                    Phân loại danh mục (Tab)
                                </Typography>
                                <FormControl fullWidth size="small">
                                    <Select
                                        value={category}
                                        onChange={(e) => setCategory(e.target.value)}
                                    >
                                        <MenuItem value="Slots">Slots (Nổ hũ)</MenuItem>
                                        <MenuItem value="Live">Live Casino</MenuItem>
                                        <MenuItem value="Sports">Sports (Thể thao)</MenuItem>
                                        <MenuItem value="Fish">Fish (Bắn cá)</MenuItem>
                                        <MenuItem value="PVP">PVP (Đối kháng)</MenuItem>
                                        <MenuItem value="Lottery">Lottery (Xổ số)</MenuItem>
                                        <MenuItem value="Cockfight">Cockfight (Đá gà)</MenuItem>
                                        <MenuItem value="Esports">Esports (Thể thao điện tử)</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>

                            <Box>
                                <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "700", color: "text.secondary", textTransform: "uppercase" }}>
                                    Trạng thái hoạt động
                                </Typography>
                                <FormControl fullWidth size="small">
                                    <Select
                                        value={status}
                                        onChange={(e) => setStatus(e.target.value)}
                                    >
                                        <MenuItem value="Active">Hoạt động</MenuItem>
                                        <MenuItem value="Maintenance">Bảo trì</MenuItem>
                                        <MenuItem value="Disabled">Tắt sảnh</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>

                            <Box>
                                <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "700", color: "text.secondary", textTransform: "uppercase" }}>
                                    Thứ tự hiển thị
                                </Typography>
                                <TextField
                                    type="number"
                                    value={sortOrder}
                                    onChange={(e) => setSortOrder(e.target.value)}
                                    fullWidth
                                    size="small"
                                    placeholder="Thứ tự hiển thị (tăng dần)"
                                />
                            </Box>
                        </Grid>

                        {/* Cột phải: Cấu hình API và các tham số khác */}
                        <Grid item xs={12} md={6} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                            <Box sx={{ p: 2, border: "1px dashed #2196f3", borderRadius: "8px", bgcolor: "#f4faff" }}>
                                <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: "bold", color: "#1976d2" }}>
                                    Nhập mã sảnh cho 3 loại API
                                </Typography>

                                <Box sx={{ mb: 1.5 }}>
                                    <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "700", color: "text.secondary", textTransform: "uppercase" }}>
                                        Mã API LeYi (codeLeYi)
                                    </Typography>
                                    <TextField
                                        value={codeLeYi}
                                        onChange={(e) => setCodeLeYi(e.target.value)}
                                        fullWidth
                                        size="small"
                                        placeholder="Nhập mã sảnh cho API LeYi..."
                                    />
                                </Box>

                                <Box sx={{ mb: 1.5 }}>
                                    <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "700", color: "text.secondary", textTransform: "uppercase" }}>
                                        Mã API FS (codeFS)
                                    </Typography>
                                    <TextField
                                        value={codeFS}
                                        onChange={(e) => setCodeFS(e.target.value)}
                                        fullWidth
                                        size="small"
                                        placeholder="Nhập mã sảnh cho API FS..."
                                    />
                                </Box>

                                <Box>
                                    <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "700", color: "text.secondary", textTransform: "uppercase" }}>
                                        Mã API TCG (productType)
                                    </Typography>
                                    <TextField
                                        value={productType}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            setProductType(val);
                                            setCodeLeYi(mapTcgToLeyi(val) || code.toLowerCase());
                                            setCodeFS(mapTcgToFs(val) || code.toLowerCase());
                                        }}
                                        fullWidth
                                        size="small"
                                        placeholder="Ví dụ: 140 (JILI), 174 (SABA)..."
                                    />
                                </Box>
                            </Box>

                            <Box>
                                <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "700", color: "text.secondary", textTransform: "uppercase" }}>
                                    Mã game kích hoạt mặc định (gameCode)
                                </Typography>
                                <TextField
                                    value={gameCode}
                                    onChange={(e) => setGameCode(e.target.value)}
                                    fullWidth
                                    size="small"
                                    placeholder="Ví dụ: 0 hoặc lobby"
                                />
                            </Box>

                            <Box>
                                <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "700", color: "text.secondary", textTransform: "uppercase" }}>
                                    Loại Game (gameType)
                                </Typography>
                                <TextField
                                    value={gameType}
                                    onChange={(e) => setGameType(e.target.value)}
                                    fullWidth
                                    size="small"
                                    placeholder="Ví dụ: RNG, LIVE, SPORTS, PVP, FISH..."
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            <Divider sx={{ my: 1 }} />
                            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold" }}>
                                Cấu hình hình ảnh sảnh game (Ảnh nền & Logo)
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 2, p: 1.5, border: "1px solid #1976d2", borderRadius: "8px", bgcolor: "#f8f9fa" }}>
                                <Box sx={{ flexGrow: 1 }}>
                                    <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "700", color: "#1976d2", textTransform: "uppercase" }}>
                                        Ảnh sảnh gốc (image)
                                    </Typography>
                                    <TextField
                                        value={image}
                                        onChange={(e) => setImage(e.target.value)}
                                        fullWidth
                                        size="small"
                                        placeholder="Liên kết hình ảnh sảnh gốc (Ví dụ: /images/lobbies/saba.png)..."
                                    />
                                </Box>
                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", minWidth: "70px" }}>
                                    <Typography variant="caption" sx={{ mb: 0.5, fontWeight: "700", fontSize: "11px", color: "text.secondary" }}>Ảnh sảnh</Typography>
                                    <input 
                                        type="file" 
                                        id="upload-image" 
                                        style={{ display: "none" }} 
                                        accept="image/*" 
                                        onChange={(e) => handleUploadImage(e, "image")} 
                                    />
                                    <Avatar
                                        src={getImageUrl(image)}
                                        alt="Image Preview"
                                        variant="rounded"
                                        title="Click để tải ảnh mới lên"
                                        sx={{ 
                                            width: 75, 
                                            height: 75, 
                                            bgcolor: "#eee", 
                                            border: "1px solid #1976d2",
                                            cursor: "pointer",
                                            transition: "0.2s",
                                            "&:hover": {
                                                opacity: 0.7,
                                                transform: "scale(1.05)"
                                            }
                                        }}
                                        onClick={() => document.getElementById("upload-image").click()}
                                    />
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 2, p: 1.5, border: "1px solid #eee", borderRadius: "8px" }}>
                                <Box sx={{ flexGrow: 1 }}>
                                    <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "700", color: "text.secondary", textTransform: "uppercase" }}>
                                        Ảnh nền sảnh PC (imagePc)
                                    </Typography>
                                    <TextField
                                        value={imagePc}
                                        onChange={(e) => setImagePc(e.target.value)}
                                        fullWidth
                                        size="small"
                                        placeholder="Liên kết hình ảnh nền PC..."
                                    />
                                </Box>
                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", minWidth: "70px" }}>
                                    <Typography variant="caption" sx={{ mb: 0.5, fontWeight: "700", fontSize: "11px", color: "text.secondary" }}>BG PC</Typography>
                                    <input 
                                        type="file" 
                                        id="upload-imagePc" 
                                        style={{ display: "none" }} 
                                        accept="image/*" 
                                        onChange={(e) => handleUploadImage(e, "imagePc")} 
                                    />
                                    <Avatar
                                        src={getImageUrl(imagePc)}
                                        alt="BG PC Preview"
                                        variant="rounded"
                                        title="Click để tải ảnh mới lên"
                                        sx={{ 
                                            width: 75, 
                                            height: 75, 
                                            bgcolor: "#eee", 
                                            border: "1px solid #ccc",
                                            cursor: "pointer",
                                            transition: "0.2s",
                                            "&:hover": {
                                                opacity: 0.7,
                                                transform: "scale(1.05)"
                                            }
                                        }}
                                        onClick={() => document.getElementById("upload-imagePc").click()}
                                    />
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 2, p: 1.5, border: "1px solid #eee", borderRadius: "8px" }}>
                                <Box sx={{ flexGrow: 1 }}>
                                    <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "700", color: "text.secondary", textTransform: "uppercase" }}>
                                        Ảnh nền sảnh Mobile (imageMobile)
                                    </Typography>
                                    <TextField
                                        value={imageMobile}
                                        onChange={(e) => setImageMobile(e.target.value)}
                                        fullWidth
                                        size="small"
                                        placeholder="Liên kết hình ảnh nền Mobile..."
                                    />
                                </Box>
                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", minWidth: "70px" }}>
                                    <Typography variant="caption" sx={{ mb: 0.5, fontWeight: "700", fontSize: "11px", color: "text.secondary" }}>BG Mobile</Typography>
                                    <input 
                                        type="file" 
                                        id="upload-imageMobile" 
                                        style={{ display: "none" }} 
                                        accept="image/*" 
                                        onChange={(e) => handleUploadImage(e, "imageMobile")} 
                                    />
                                    <Avatar
                                        src={getImageUrl(imageMobile)}
                                        alt="BG Mobile Preview"
                                        variant="rounded"
                                        title="Click để tải ảnh mới lên"
                                        sx={{ 
                                            width: 75, 
                                            height: 75, 
                                            bgcolor: "#eee", 
                                            border: "1px solid #ccc",
                                            cursor: "pointer",
                                            transition: "0.2s",
                                            "&:hover": {
                                                opacity: 0.7,
                                                transform: "scale(1.05)"
                                            }
                                        }}
                                        onClick={() => document.getElementById("upload-imageMobile").click()}
                                    />
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 2, p: 1.5, border: "1px solid #eee", borderRadius: "8px" }}>
                                <Box sx={{ flexGrow: 1 }}>
                                    <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "700", color: "text.secondary", textTransform: "uppercase" }}>
                                        Logo sảnh PC (logoPc)
                                    </Typography>
                                    <TextField
                                        value={logoPc}
                                        onChange={(e) => setLogoPc(e.target.value)}
                                        fullWidth
                                        size="small"
                                        placeholder="Liên kết logo PC..."
                                    />
                                </Box>
                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", minWidth: "70px" }}>
                                    <Typography variant="caption" sx={{ mb: 0.5, fontWeight: "700", fontSize: "11px", color: "text.secondary" }}>Logo PC</Typography>
                                    <input 
                                        type="file" 
                                        id="upload-logoPc" 
                                        style={{ display: "none" }} 
                                        accept="image/*" 
                                        onChange={(e) => handleUploadImage(e, "logoPc")} 
                                    />
                                    <Avatar
                                        src={getImageUrl(logoPc)}
                                        alt="Logo PC Preview"
                                        variant="rounded"
                                        title="Click để tải ảnh mới lên"
                                        sx={{ 
                                            width: 75, 
                                            height: 75, 
                                            bgcolor: "#eee", 
                                            border: "1px solid #ccc",
                                            cursor: "pointer",
                                            transition: "0.2s",
                                            "&:hover": {
                                                opacity: 0.7,
                                                transform: "scale(1.05)"
                                            }
                                        }}
                                        onClick={() => document.getElementById("upload-logoPc").click()}
                                    />
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 2, p: 1.5, border: "1px solid #eee", borderRadius: "8px" }}>
                                <Box sx={{ flexGrow: 1 }}>
                                    <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "700", color: "text.secondary", textTransform: "uppercase" }}>
                                        Logo sảnh Mobile (logoMobile)
                                    </Typography>
                                    <TextField
                                        value={logoMobile}
                                        onChange={(e) => setLogoMobile(e.target.value)}
                                        fullWidth
                                        size="small"
                                        placeholder="Liên kết logo Mobile..."
                                    />
                                </Box>
                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", minWidth: "70px" }}>
                                    <Typography variant="caption" sx={{ mb: 0.5, fontWeight: "700", fontSize: "11px", color: "text.secondary" }}>Logo Mobile</Typography>
                                    <input 
                                        type="file" 
                                        id="upload-logoMobile" 
                                        style={{ display: "none" }} 
                                        accept="image/*" 
                                        onChange={(e) => handleUploadImage(e, "logoMobile")} 
                                    />
                                    <Avatar
                                        src={getImageUrl(logoMobile)}
                                        alt="Logo Mobile Preview"
                                        variant="rounded"
                                        title="Click để tải ảnh mới lên"
                                        sx={{ 
                                            width: 75, 
                                            height: 75, 
                                            bgcolor: "#eee", 
                                            border: "1px solid #ccc",
                                            cursor: "pointer",
                                            transition: "0.2s",
                                            "&:hover": {
                                                opacity: 0.7,
                                                transform: "scale(1.05)"
                                            }
                                        }}
                                        onClick={() => document.getElementById("upload-logoMobile").click()}
                                    />
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 3, borderTop: "1px solid #eee", pt: 1.5 }}>
                    <Button onClick={handleClose} variant="outlined" color="inherit">Hủy</Button>
                    <Button onClick={handleSave} color="primary" variant="contained">Lưu cấu hình</Button>
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
}

export default Lobbies;
